import { novelAspects } from "@/mocks/siteContent";

export default function NovelSection() {
  return (
    <section id="novel" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
          <div className="w-full lg:w-1/2">
            <div className="w-full aspect-[4/3] rounded-lg overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=cozy%20warm%20reading%20scene%20abstract%20illustration%20of%20an%20open%20book%20on%20a%20wooden%20table%20beside%20a%20cup%20of%20tea%2C%20soft%20lamplight%2C%20cream%20ochre%20and%20brown%20palette%2C%20painterly%20artistic%20style%2C%20calm%20literary%20atmosphere%2C%20no%20text%2C%20editorial%20aesthetic&width=1000&height=750&seq=nw-novel-01&orientation=landscape"
                alt="小说版阅读场景示意图"
                title="邻居的妻子小说版剧情梳理"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <span className="inline-flex items-center gap-2 text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-4">
              <i className="ri-book-open-line" aria-hidden="true"></i>
              小说版剧情梳理
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              文字把同一段故事撑得更开，重点在「为什么」而非「发生了什么」
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              小说版本的独特之处，在于它能把角色的内心摊开给你看。同一个情节，在短剧里可能只用一场戏带过，在小说里却能被拆成好几章的心理活动。
            </p>

            <div className="mt-8 space-y-5">
              {novelAspects.map((aspect, idx) => (
                <div key={aspect.title} className="flex gap-4">
                  <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-accent-500 text-background-50 font-heading font-bold text-sm">
                    {idx + 1}
                  </span>
                  <div>
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">
                      {aspect.title}
                    </h3>
                    <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{aspect.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}